import { GatewayGarantieFinanciere } from "@conformite/gateway";
import {
  MaxWidthContent,
  TagConformite,
  Button,
  Card,
} from "@endya-conformite/ui-kit";
import styles from "../ConformiteGarantieFinanciere.module.scss";
import {
  ConformiteGarantieFinanciereEditFormIas,
  useConformiteGarantieFinanciereIasEdit,
} from "../edit/ConformiteGarantieFinanciereEditFormIas";

type ConformiteGarantieFinanciereReadIasProps = {
  garantieFinanciere: GatewayGarantieFinanciere.ConformiteGarantieFinanciereIas | null;
  isConforme: boolean;
  setToEdit: () => void;
  millesime: number;
  siren: string;
};
export function ConformiteGarantieFinanciereReadIas({
  garantieFinanciere,
  isConforme,
  setToEdit,
  millesime,
  siren,
}: ConformiteGarantieFinanciereReadIasProps) {
  const { formConfig } = useConformiteGarantieFinanciereIasEdit(
    siren,
    millesime,
    garantieFinanciere,
    () => null
  );
  return (
    <MaxWidthContent size="large">
      <Card className={styles.content}>
        <div className={styles.cardHeader}>
          <div className={styles.cardHeaderLeft}>
            <h3>Formulaire</h3>
            <TagConformite isConforme={isConforme} year={millesime} />
          </div>
          <Button onClick={setToEdit}>Modifier</Button>
        </div>
        <ConformiteGarantieFinanciereEditFormIas
          siren={siren}
          garantieFinanciere={garantieFinanciere}
          millesime={millesime}
          formConfig={formConfig}
          disabled
        />
      </Card>
    </MaxWidthContent>
  );
}
